import { DatePicker, Input, Tag, TimePicker, Form, Row, Col, Space, Typography, Select } from "antd";
import TextArea from "antd/es/input/TextArea";
import React, { useState } from "react";
import jaipurLocalities from "./cityList";
import moment from "moment";
import { useNavigate } from "react-router-dom";

const { Title, Text } = Typography;
const { Option } = Select;

const AddLocation = () => {
  const [tags, setTags] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [error,setError]=useState()
  const [inputFields, setInputFields] = useState({
    location: "",
    email: "",
    address: "",
    postal: "",
    resource: [],
    startTime: "",
    endTime: "",
  });
  const navigate=useNavigate();
  console.log(inputFields)

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

 
// Function to handle adding a tag
const handleInputConfirm = () => {
  if (inputValue && !tags.includes(inputValue)) {
    const newTags = [...tags, inputValue];
    setTags(newTags); 
    setInputFields((prev) => ({
      ...prev,
      resource: newTags, 
    }));
  }
  setInputValue(""); 
};

// Function to handle tag removal
const handleClose = (removedTag) => {
  const filteredTags = tags.filter((tag) => tag !== removedTag);
  setTags(filteredTags);
  setInputFields((prev) => ({
    ...prev,
    resource: filteredTags, 
  }));
};

  const handleInputField = (name, value) => {
    console.log(`Updated field: ${name}`, value);
    setInputFields((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  
  const handlesave = async () => {
    try {
      const response = await fetch("http://localhost:5000/api/add-location", {
        method: "POST", 
        headers: {
          "Content-Type": "application/json", 
        },
        body: JSON.stringify(inputFields), 
      });
  
      const data = await response.json();
      // console.log("Response:", data);
  
      if (response.ok) {
        alert("Location added successfully!");
        navigate("/locationlist")
        setInputFields({
          location: "",
          email: "",
          address: "",
          postal: "",
          resource: [],
          startTime: "",
          endTime: "",
        });
        setTags([])
      } else {
        setError(data?.error?.errors)
        // alert("Failed to add location.");
      }
    } catch (error) {
      // console.error("Error saving location:", error);
      alert("An error occurred while saving.");
    }
  };
  
console.log("error",error)

  return (
    <div style={{ maxWidth: "800px", margin: "auto", padding: "20px", border: "1px solid orange", borderRadius: "10px" }}>
      <Title level={3} style={{ textAlign: "center", marginBottom: "20px" }}>
        Add Location
      </Title>

      <Form layout="vertical">
        <Row gutter={[16, 16]}>
          {/* Location Name */}
          <Col xs={24} sm={12}>
            <Form.Item label="Location">
              <Select
                value={inputFields.location}
                onChange={(value) => handleInputField("location", value)}
                placeholder="Select location"
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
              >
                {jaipurLocalities.map((city) => (
                  <Option key={city} value={city}>
                    {city}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            {error && error.location && <span style={{color:"red"}}>This field is required</span>}
          </Col>

          {/* Email */}
          <Col xs={24} sm={12}>
            <Form.Item label="Email">
              <Input
                type="email"
                placeholder="Enter email"
                name="email"
                value={inputFields.email}
                onChange={(e) => handleInputField("email", e.target.value)}
              />
            </Form.Item>
            {error && error.email && <span style={{color:"red"}}>This field is required</span>}

          </Col>

          {/* Address */}
          <Col xs={24}>
            <Form.Item label="Address">
              <TextArea
                placeholder="Enter address"
                rows={3}
                value={inputFields.address}
                onChange={(e) => handleInputField("address", e.target.value)}
              />
            </Form.Item>
            {error && error.address && <span style={{color:"red"}}>This field is required</span>}

          </Col>

          {/* Postal Code */}
          <Col xs={24} sm={12}>
            <Form.Item label="Postal Code">
              <Input
                placeholder="Enter postal code"
                value={inputFields.postal}
                onChange={(e) => handleInputField("postal", e.target.value)}
              />
            </Form.Item>
            {error && error.postal && <span style={{color:"red"}}>This field is required</span>}

          </Col>

          {/* Resource Name (Tags) */}
          <Col xs={24}>
            <Form.Item label="Resource Name">
              <Input
                placeholder="Enter resource name"
                value={inputValue}
                onChange={handleInputChange}
                onPressEnter={handleInputConfirm}
              />
              <Space wrap style={{ marginTop: "10px" }}>
                {tags.map((tag) => (
                  <Tag key={tag} closable onClose={() => handleClose(tag)}>
                    {tag}
                  </Tag>
                ))}
              </Space>
            </Form.Item>
            {error && error.resource && <span style={{color:"red"}}>This field is required</span>}

          </Col>

          {/* Business Time */}
          <Col xs={24}>
            <Text strong>Business Time for this Location</Text>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item label="Start Time">
              <TimePicker
                placeholder="Select start time"
                format="HH:mm"
                style={{ width: "100%" }}
                value={inputFields.startTime ? moment(inputFields.startTime, "HH:mm") : null}
                onChange={(time) => handleInputField("startTime", time ? time.format("HH:mm") : "")}
              />
            </Form.Item>
            {error && error.startTime && <span style={{color:"red"}}>This field is required</span>}

          </Col>
          <Col xs={24} sm={12}>
            <Form.Item label="End Time">
              <TimePicker
                placeholder="Select end time"
                format="HH:mm"
                style={{ width: "100%" }}
                value={inputFields.endTime ? moment(inputFields.endTime, "HH:mm") : null}
                onChange={(time) => handleInputField("endTime", time ? time.format("HH:mm") : "")}
              />
            </Form.Item>
            {error && error.endTime && <span style={{color:"red"}}>This field is required</span>}

          </Col>
        </Row>
      </Form>
      <button onClick={handlesave} style={{background:"orange",border:"1px solid orange",borderRadius:"5px",padding:"5px 20px"}}>save</button>
    </div>
  );
};

export default AddLocation;

